/**
 * Created by Lily on 2019/4/15.
 */

import { applyMiddleware,createStore, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';
import Device from '@/reducer/device';
import Dictionary from '@/reducer/Dictionary';
import { doReducer } from '@/reducer/reducer_helper';
// import logger from 'redux-logger';

const reducers = combineReducers({
    device: (state={}, action)=>doReducer(state, action, Device.REDUCER_TABLE),
    dictionary: (state={}, action)=>doReducer(state, action, Dictionary.REDUCER_TABLE),
})

const initialState = {
    device: Device.initialState,
    dictionary: Dictionary.initialState,
};

const store = createStore(reducers,
    initialState,
    applyMiddleware(
        thunkMiddleware,
        // logger
    )
)

export default store